import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSwitch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12.75 15.75 3.25 3.5 3.25-3.5M4.75 8.25 8 4.75l3.25 3.5M16 8.75v10.5M8 4.75v10.5"
    />
  </svg>
);
export default SvgSwitch;
